import { GameConstants } from "../GameConstants";

export class DottySlider extends Phaser.GameObjects.Container { // Array of dots with a current one highligted, commonly used for page indication  

    public scene: Phaser.Scene;
    public dotRadius: number = 0;

    private dotArray: Phaser.GameObjects.Graphics[];
    private arrowLeft: Phaser.GameObjects.Graphics;
    private arrowRight: Phaser.GameObjects.Graphics;

    private currentDot: number = 0;
    private dotSeparation: number = 0;
    private centered: boolean = false;
    private showArrows: boolean = false;

    private dotAmount: number = 0;

    private highlightDotColor: Phaser.Display.Color;
    private highlightDotAlpha: number;

    private normalDotColor: Phaser.Display.Color;
    private normalDotAlpha: number;

    constructor(
        scene: Phaser.Scene,
        x: number,
        y: number,
        showArrows: boolean) {

        super(scene, x, y);

        this.scene = scene;

        this.dotAmount = null;
        this.currentDot = null;
        this.arrowLeft = null;
        this.arrowRight = null;

        this.showArrows = showArrows;
        this.dotRadius = 9;
        this.centered = true;
        this.dotSeparation = 35;

        this.highlightDotColor = new Phaser.Display.Color(112, 225, 79);
        this.highlightDotAlpha = 1;

        this.normalDotColor = new Phaser.Display.Color(200, 200, 200);
        this.normalDotAlpha = 1;
    }

    public onCategoryChanged(dotsAmount: number, currentDot: number = 0): void {

        this.dotAmount = dotsAmount;
        this.currentDot = currentDot;
        this.createSlider();
    }

    public setDotStyleHighlight(dotColor: Phaser.Display.Color, dotAlpha: number): void {

        this.highlightDotColor = dotColor;
        this.highlightDotAlpha = dotAlpha;

        this.createSlider();
    }

    public setDotStyleNormal(dotColor: Phaser.Display.Color, dotAlpha: number): void {

        this.normalDotColor = dotColor;
        this.normalDotAlpha = dotAlpha;

        this.createSlider();
    }

    public setSliderShape(dotSeparation: number, dotRadius: number): void {

        this.dotSeparation = dotSeparation;
        this.dotRadius = dotRadius;

        this.createSlider();
    }

    public goToPage(page: number): void {

        this.currentDot = page;
        this.createSlider();
    }

    public getCurrentPage(): number {

        return this.currentDot;
    }

    private createSlider(): void {

        this.dotArray = [];

        let offset = -this.dotSeparation * ((this.dotAmount - 1) / 2);

        this.refreshArrows(offset);

        for (let i = 0; i < this.dotAmount; i++) {

            let newDot = new Phaser.GameObjects.Graphics(this.scene);
            newDot.fillStyle(this.normalDotColor.color, this.normalDotAlpha);

            if (i === this.currentDot) {
                newDot.fillStyle(this.highlightDotColor.color, this.highlightDotAlpha);
            }

            newDot.fillCircle(offset, 0, this.dotRadius);
            offset += this.dotSeparation;

            this.dotArray.push(newDot);
            this.add(newDot);
        }

        if (this.centered) {
            this.centerSlider();
        }
    }

    private refreshArrows(offset: number) {

        if (this.arrowLeft) {
            this.arrowLeft.clear();
        }
        if (this.arrowRight) {
            this.arrowRight.clear();
        }

        const arrowHeight = 8;
        const arrowWidth = 8;
        const distFromDots = GameConstants.GAME_WIDTH * .15;
        const lineWidth = 5;

        if (this.showArrows) {

            if (this.currentDot > 0) {
                this.arrowLeft = new Phaser.GameObjects.Graphics(this.scene);
                this.arrowLeft.lineStyle(lineWidth, this.normalDotColor.color);
                this.arrowLeft.beginPath();
                this.arrowLeft.moveTo(- distFromDots, -arrowHeight);
                this.arrowLeft.lineTo(- distFromDots - arrowWidth, 0);
                this.arrowLeft.lineTo(- distFromDots, arrowHeight);
                this.arrowLeft.strokePath();
                this.add(this.arrowLeft);

                const tween = this.scene.tweens.create({
                    targets: [this.arrowLeft],
                    x: this.arrowLeft.x - 5,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 500,
                    repeat: -1
                });

                tween.play(true);
            }

            if (this.currentDot < this.dotAmount - 1) {
                this.arrowRight = new Phaser.GameObjects.Graphics(this.scene);
                this.arrowRight.lineStyle(lineWidth, this.normalDotColor.color);
                this.arrowRight.beginPath();
                this.arrowRight.moveTo(distFromDots, -arrowHeight);
                this.arrowRight.lineTo(distFromDots + arrowWidth, 0);
                this.arrowRight.lineTo(distFromDots, arrowHeight);
                this.arrowRight.strokePath();
                this.add(this.arrowRight);

                const tween = this.scene.tweens.create({
                    targets: [this.arrowRight],
                    x: this.arrowRight.x + 5,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 500,
                    repeat: -1
                });

                tween.play(true);
            }
        }
    }

    private centerSlider(): void {

        this.x -= this.width;
        this.y -= this.width;
    }
}
